export default __webpack_public_path__ + "static/media/info_step.4f35096c.svg";